import React, { useState } from 'react'

export const HospitalBasicInfoContext = React.createContext()

export function HospitalBasicInfoContextProvider (props) {
  const [hospitalBasicInfo, setHospitalBasicInfo] = useState({})
  const [foodsImageArray, setFoodsImageArray] = useState({})

  return (
    <HospitalBasicInfoContext.Provider
      value={{
        hospitalBasicInfo: hospitalBasicInfo,
        setHospitalBasicInfo: setHospitalBasicInfo,
        foodsImageArray: foodsImageArray,
        setFoodsImageArray: setFoodsImageArray
      }}
    >
      {props.children}
    </HospitalBasicInfoContext.Provider>
  )
}
